export const disableBodyScroll = () => {
  document.body.style.overflow = 'hidden';
};

export const enableBodyScroll = () => {
  document.body.style.overflow = 'unset';
};

export const toggleBodyScroll = (isDisabled: boolean) => {
  if (isDisabled) {
    disableBodyScroll();
  } else {
    enableBodyScroll();
  }
};

/**
 * Reference-counted body-scroll lock.
 *
 * `document.body.style.overflow` is a SINGLE shared property, so multiple
 * overlays that each lock/unlock it (e.g. `CheckoutBottomSheet` + a sibling
 * `Drawer`/`ScreenDrawer`) used to clobber each other: closing the sub-drawer
 * ran `enableBodyScroll()` and tore down the lock the still-open sheet
 * depended on (scroll-through behind the backdrop on iOS Safari).
 *
 * Each owner now locks with its OWN token and releases with the same token;
 * the body only unlocks once EVERY owner has released. `Set` semantics make
 * repeated or unknown-token releases harmless (idempotent), which also absorbs
 * `Drawer`'s double release-on-close.
 */
const activeScrollLocks = new Set<string>();

const applyRefCountedBodyScroll = () => {
  toggleBodyScroll(activeScrollLocks.size > 0);
};

export const lockBodyScroll = (token: string) => {
  activeScrollLocks.add(token);
  applyRefCountedBodyScroll();
};

export const unlockBodyScroll = (token: string) => {
  activeScrollLocks.delete(token);
  applyRefCountedBodyScroll();
};
